import React from 'react';

interface GaugeChartProps {
  value: number;
  total: number;
  title?: string;
  unit?: string;
  lowThreshold?: number; // Below this percentage, color is red
  colorLow?: string;
  colorHigh?: string;
  width?: number;
  height?: number;
}

export const GaugeChart: React.FC<GaugeChartProps> = ({
  value,
  total,
  title = 'Disponibles',
  unit = 'kg',
  lowThreshold = 0.3,
  colorLow = '#ff4444',
  colorHigh = '#7ed321',
  width = 200,
  height = 120,
}) => {
  const percentage = total > 0 ? value / total : 0;
  const arcLength = 251.2; // Approximate arc length for the semicircle
  const strokeDasharray = `${percentage * arcLength} ${arcLength}`;
  const gaugeColor = percentage >= lowThreshold ? colorHigh : colorLow;

  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ marginBottom: '10px', fontSize: '18px', fontWeight: 'bold' }}>
        {title}
      </h3>
      <div style={{ position: 'relative', width: `${width}px`, height: `${height}px` }}>
        <svg viewBox='0 0 200 120' style={{ width: '100%', height: '100%' }}>
          {/* Background arc (gray) */}
          <path
            d='M 20 100 A 80 80 0 0 1 180 100'
            fill='none'
            stroke='#e0e0e0'
            strokeWidth='30'
            strokeLinecap='round'
          />
          {/* Colored arc based on percentage */}
          <path
            d='M 20 100 A 80 80 0 0 1 180 100'
            fill='none'
            stroke={gaugeColor}
            strokeWidth='30'
            strokeLinecap='round'
            strokeDasharray={strokeDasharray}
          />
        </svg>
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -20%)',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
            {value.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>{unit}</div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '12px',
          color: '#999',
          marginTop: '5px',
        }}
      >
        <span>0</span>
        <span>{total.toLocaleString('en-US', { maximumFractionDigits: 0 })}</span>
      </div>
    </div>
  );
};
